import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';


// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentReset from '@material-ui/icons/DeleteSweep';
import IconContentRemB from '@material-ui/icons/RemoveCircle';

// import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import { DatePicker } from 'material-ui-pickers';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

//InnerComponents imports
import NormalField from './innerComponents/NormalField';
import SelectAutocomplete from './innerComponents/SelectAutocomplete';
import CustomLoader from './innerComponents/CustomLoader';

import axios from 'axios';

import crypto from 'crypto';

import moment from 'moment';
// Assets imports
import '../styles/NewProject.css';
import Certificate from './innerComponents/Certificate';


const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    fieldStyle: {
        minHeight: "72px",
        width: "100%",
    },

    buttonStyle: {
        marginRight: 12,
    },

    paperStyle: {
        // General styles for paper
        width: "60%",
        margin: "0 auto",
        height: "auto",
    }
});

class UpdateCertificate extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    suggestions: [],
    value: 0,
  };

  _resetForm(form) {
    form.reset();
  }

  _handleClose = () => {

    alert("The Certificate was successfully updated")

    const tab = this.props.location.state? this.props.location.state.tab : 0;

    this.props.history.push({
      pathname: "/users/list",
      state: { refetch: false,
          tab: tab }
    })

  }

  _updateCertificate = async  values => {

    const certificateId = values.certificateId;
    const expiryDateUnformatted = values.expiryDate ? moment(new Date(values.expiryDate)) : moment(new Date(values.certificate.expiryDate));
    expiryDateUnformatted.set({ hour: 23, minute: 59, second: 59 });
    const expiryDate = expiryDateUnformatted.format('YYYY-MM-DDTHH:mm:ss.SSS');
    const certificationId = values.certificationId ? values.certificationId : values.certificate.certification.id;

    await this.props.update_certificate({
      variables: {
        certificateId,
        expiryDate,
        certificationId
      }
    })
    .then(({ data }) => {
      this._handleClose();
    })
    .catch((e) => {
      alert("Error while updating certificate")
      console.log(e);
    });

  }

  render() {

    const required = value => (value ? undefined : 'Required field');

    const SelectAutocompleteAdapter = ({ input, meta, ...rest }) => (
      <SelectAutocomplete
        {...input}
        {...rest}
        input={input}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const DatePickerAdapter = ({ input, meta, ...rest }) => (
      <DatePicker
          {...input}
          {...rest}
          disableOpenOnEnter
          format="YYYY-MM-DD"
          invalidLabel=""
          onChange={(event) => input.onChange(event.format('YYYY-MM-DDTHH:mm:ss.SSS'))}
          error={meta.touched && meta.error !== undefined}
          helperText={meta.touched ? meta.error : ''}
      />
    );

    const { classes } = this.props;
    const tab = this.props.location.state? this.props.location.state.tab : 0;

    // Check if the query response is being loaded
    if (this.props.all_certifications_query && this.props.all_certifications_query.loading) {
      return <CustomLoader label={'Loading Certifications'}/>
  }

    // Check if there were errors
    if (this.props.all_certifications_query && this.props.all_certifications_query.error) {
        return <div> Certifications Could not be loaded </div>
    }

    // Check if the query response is being loaded
    if (this.props.certification_by_id_query && this.props.certification_by_id_query.loading) {
      return <CustomLoader label={'Loading User Certificate'}/>
    }

    // Check if there were errors
    if (this.props.certification_by_id_query && this.props.certification_by_id_query.error) {
      return <div> User Certificate Could not be loaded </div>
    }

    const certificate = this.props.certification_by_id_query.certificate;

    const all_certifications = this.props.all_certifications_query.certifications

    const certificationSuggestions = all_certifications.map(certification => ({
      value: certification.id,
      label: certification.name
    }))

    return (
      <Paper className={classes.paperStyle} elevation={1}>
          <div>
          <Form
            onSubmit={this._updateCertificate}
            initialValues={{ certificate: certificate,
                certificateId: this.props.match.params.id
              }}
            mutators={{
                          ...arrayMutators
                      }}
            render={({ handleSubmit, submitting, pristine, values, form }) => (
              <form onSubmit={handleSubmit}>
                <div className="NewProject-header">
                  <div className="NewProject-title">
                      <span>Edit Certificate</span>
                  </div>
                  <div className="NewProject-actions">
                      <Button
                          color="primary"
                          onClick={()=>this.props.history.push({
                              pathname: "/users/list",
                              state: { refetch: false,
                                  tab: tab }
                          })}
                      ><IconContentRemB style={{ marginRight: 8 }} /> Cancel</Button>
                  </div>
                </div>
                <div className="NewProject-content">
                  <div>
                    <NormalField
                      label="User Name"
                      input={certificate.user.fullName} />

                    <NormalField
                      label="Type of certification"
                      input={certificate.certification.name} />

                    <NormalField
                      label="Current expiration date"
                      input={moment(new Date(certificate.expiryDate)).format('YYYY-MM-DD')} />
                  </div>
                  <div>
                      <Field
                        name="certificationId"
                        // validate={required}
                        mLabel="Certification"
                        mValue={values["certificationId"]}
                        component={SelectAutocompleteAdapter}
                        placeholder="Type to search a certification"
                        options={certificationSuggestions}
                        className={classes.fieldStyle} />
                  </div>
                  <div>
                    <Field
                      name="expiryDate"
                      // validate={required}
                      component={DatePickerAdapter}
                      label="New Expiry Date"
                      className={classes.fieldStyle}
                    />
                  </div>
                </div>
                <div className="NewProject-detailFooter">
                  <div className="buttons">

                    <Button variant="contained"
                        color="primary"
                        type="submit"
                        disabled={submitting || pristine}
                        className={classes.buttonStyle}
                    ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>

                    <Button variant="contained"
                        type="button"
                        color="secondary"
                        onClick={this._resetForm.bind(this, form)}
                        disabled={submitting || pristine}
                        className={classes.buttonStyle}
                    ><IconContentReset style={{ marginRight: 8 }} /> Reset</Button>

                  </div>
                </div>

              </form>
            )}
          />
          </div>
      </Paper>
    );
  }

}

const CERTIFICATION_BY_ID_QUERY = gql`
  query certification_query ($id: ID!) {
  certificate (id: $id){
    id
    user {
      fullName
    }
    expiryDate
    sha
    baseFileName
    certification {
      id
      name
    }
  }
}
`;

const UPDATE_CERTIFICATE = gql`
mutation updateCertificate($certificateId: ID!, $expiryDate: String!, $certificationId: ID!){
    updateCertificate(certificateId: $certificateId, input:{expiryDate:$expiryDate, certificationId:$certificationId}){
    id
  }
}
`;

const ALL_CERTIFICATIONS_QUERY = gql`
    query{
        certifications{
        id
        name
        }
    }
`;

export default compose(
  graphql(UPDATE_CERTIFICATE, {
    name: 'update_certificate',
    options: {
      refetchQueries: ["all_certifications_query"]
    }
  }),
  graphql(CERTIFICATION_BY_ID_QUERY, {
    name: 'certification_by_id_query', options: (props) => ({ variables: { id: props.match.params.id } })
  }),
  graphql(ALL_CERTIFICATIONS_QUERY, { name: 'all_certifications_query' })

)(withStyles(styles)(UpdateCertificate));


// WEBPACK FOOTER //
// src/components/UpdateCertificate.js